<template>
  <div class="location mt-16">
    <v-img src="@/assets/img/map.png" class="location__img pa-5 pa-md-10">
      <h2 class="location__header">Контакты</h2>
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular indeterminate color="#FFA903" />
        </v-row>
      </template>
    </v-img>
    <v-card
      class="location__card rounded-0 elevation-3"
      dark
      color="#1E1C37"
      width="16.7rem"
    >
      <h3 class="mb-8">
        Пансионат<br />
        Клязьма
      </h3>
      <h5 class="mb-4">
        Московская область, городской округ Мытищи<br />
        п. Поведники
      </h5>
      <h5>
        Контакты:<br />
        +7 (985) 480-07-13<br />
        lsaran.moscow@gmail.com<br />
      </h5>
      <v-divider class="my-6 my-sm-10 location__card-divider"></v-divider>
      <v-btn class="main-btn">
        Маршрут
      </v-btn>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "Contacts"
};
</script>

<style lang="sass" scoped>
@media (max-width: 600px)
  .location
    &__img
      width: 100%
      height: 375px !important
    &__card
      position: relative !important
      width: 100% !important
      right: 0 !important
      top: 0 !important
      padding: 30px 20px 50px 20px !important
      h3
        br
          display: none !important

.location
  width: 100%
  height: 90vh
  position: relative
  &__img
    width: 100%
    position: relative
  &__pin
    width: 2rem
    height: 2.5rem
    position: absolute
    left: 50%
    top: 50%
    transform: translate(-60%, -85%)
  &__header
    color: #FFFFFF
  &__card
    position: absolute
    right: 0 !important
    top: 0 !important
    height: 90vh
    padding: 5.8rem 2.3rem 3.3rem 2.3rem
    h5
      font-size: .9rem
    &-divider
      background-color: rgba(255, 255, 255, 0.1)
</style>
